import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { Clipboard, DialogPopup } from '../components'
import { translate } from '../i18n'
import { KeyPairDetailsProps } from './KeyPairDetails.types'

function KeyPairDetails({ tenantId, keyPair, onClose }: KeyPairDetailsProps) {
    return (
        <DialogPopup
            open
            title={translate('keypairs.single')}
            onClose={onClose}
        >
            <Grid container>
                <Grid item xs={12}>
                    <Clipboard
                        label={translate('tenants.single')}
                        value={tenantId}
                    />
                    <Clipboard
                        label={translate('keypairs.id')}
                        value={keyPair.id}
                    />
                    <Clipboard
                        label={translate('keypairs.secret')}
                        value={keyPair.secret}
                    />
                </Grid>
            </Grid>
        </DialogPopup>
    )
}

export default memo(KeyPairDetails)
